module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/core-js/modules/_function-to-string.js
// module id = 191
// module chunks = 0